// Firebase configuration for Wordsheet multiplayer
// Using modular Firebase SDK for ES modules

import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyA57RwmapDdhUVW295tFDqbJXJBCv_tCxo",
    authDomain: "flydongus-wordsheet.firebaseapp.com",
    projectId: "flydongus-wordsheet",
    storageBucket: "flydongus-wordsheet.firebasestorage.app",
    messagingSenderId: "593007677790",
    appId: "1:593007677790:web:749a63367a6e01ce127fcf"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Export references for use in other modules
export const db = getFirestore(app);
export const auth = getAuth(app);

// Check if running in Discord Activity context
export function isDiscordContext() {
    // Discord embeds run in iframes with specific URL patterns
    return window.location.href.includes('discordsays.com') ||
           window.location.href.includes('.discordsays.com') ||
           window.__DISCORD__ === true;
}

// Sign in anonymously and persist the user ID (for web version)
export async function initAuth() {
    // Check localStorage for existing nickname
    const savedNickname = localStorage.getItem('wordsheet_nickname');
    const savedPlayerId = localStorage.getItem('wordsheet_player_id');

    try {
        // Sign in anonymously
        const userCredential = await signInAnonymously(auth);
        const user = userCredential.user;

        // Store player ID if not already saved (or if it changed)
        if (!savedPlayerId || savedPlayerId !== user.uid) {
            localStorage.setItem('wordsheet_player_id', user.uid);
        }

        console.log('Signed in anonymously:', user.uid);
        return {
            playerId: user.uid,
            nickname: savedNickname || null
        };
    } catch (error) {
        console.error('Anonymous auth error:', error);
        throw error;
    }
}

// Save nickname to localStorage
export function saveNickname(nickname) {
    localStorage.setItem('wordsheet_nickname', nickname);
}

// Get saved nickname
export function getSavedNickname() {
    return localStorage.getItem('wordsheet_nickname');
}

// Get current player ID
export function getPlayerId() {
    return auth.currentUser?.uid || localStorage.getItem('wordsheet_player_id');
}
